"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PreisberichtPage;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReportDisplay_1 = __importDefault(require("@/components/pbi/ReportDisplay"));
const reportConstants_1 = require("@/config/reportConstants");
const MenuContext_1 = require("@/components/menu/MenuContext");
const powerbiUtils_1 = require("@/utils/powerbiUtils");
const react_router_dom_1 = require("react-router-dom");
function PreisberichtPage() {
    const location = (0, react_router_dom_1.useLocation)();
    const { setMenuItem } = (0, MenuContext_1.useMenu)();
    const onButtonClicked = (event) => __awaiter(this, void 0, void 0, function* () {
        if (location.pathname == "/reports/preise") {
            // Marktdaten im linken Menu auswählen, Browser-Url anpassen
            setMenuItem("marktdaten");
            window.history.replaceState({}, "", "/reports/marktdaten"); // note: does not trigger a page reload
        }
        if ((0, powerbiUtils_1.isMarktdatenButtonClicked)(event)) {
            // es wurde eine Schaltfläche auf der Marktdatenseite angeklickt, evt. Download auslösen
            yield (0, powerbiUtils_1.handleMarktdatenButtonClicked)(event);
        }
        else {
            console.log("setting preisbericht year filter");
            // es wurde eine Schaltfläche auf der Preisberichtseite angeklickt, Datumsfilter setzten
            yield (0, powerbiUtils_1.setPreisberichtYearFilter)(event.report);
        }
    });
    return ((0, jsx_runtime_1.jsx)(ReportDisplay_1.default, { className: "embed-report", reportCode: reportConstants_1.RC_MARKDATEN, bookmark: reportConstants_1.MARKTDATEN_PREISBERICHT_BOOKMARK, onButtonClicked: onButtonClicked }));
}
